import { createFileRoute } from "@tanstack/react-router";
import { Building2Icon } from "lucide-react";
import { AcceptInvitation } from "@/ui/components/team/accept-invitation";

/**
 * Public team-invitation acceptance page. Deliberately outside every auth gate
 * so an invited person — who may not have an account yet — can open their
 * link, sign in or sign up with the invited email, and join the company.
 */
export const Route = createFileRoute("/accept-invitation/$id")({
  component: AcceptInvitationPage,
});

function AcceptInvitationPage() {
  const { id } = Route.useParams();
  return (
    <main className="min-h-svh bg-muted/30 px-4 py-10">
      <div className="mx-auto w-full max-w-md space-y-6">
        <div className="flex items-center gap-2">
          <span className="flex size-8 items-center justify-center rounded-lg bg-primary/10">
            <Building2Icon className="size-4 text-primary" />
          </span>
          <div>
            <p className="font-semibold text-sm tracking-tight">HR Docket</p>
            <p className="text-muted-foreground text-xs">You've been invited to join a company.</p>
          </div>
        </div>
        <AcceptInvitation invitationId={id} />
      </div>
    </main>
  );
}
